/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType } from './FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType';
import {
    FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeFromJSON,
    FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeFromJSONTyped,
    FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeToJSON,
    FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeToJSONTyped,
} from './FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType';

/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier
 */
export interface FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier {
    /**
     * 
     * @type {FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier
     */
    Type: FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier
     */
    Id: string;
}



/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier(value: object): value is FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier {
    if (!('Type' in value) || value['Type'] === undefined) return false;
    if (!('Id' in value) || value['Id'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier {
    if (json == null) {
        return json;
    }
    return {
        
        'Type': FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeFromJSON(json['Type']),
        'Id': json['Id'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierToJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifierToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalSocialIdentifier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Type': FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeToJSON(value['Type']),
        'Id': value['Id'],
    };
}

